import { createFileRoute } from '@tanstack/react-router';
import { recipeDetailQuery, recipeSnapshotQuery } from '@/api/queries/recipes';
import { RecipeViewScreen } from '@/features/recipes/RecipeViewScreen';

type Search = { version?: number };

export const Route = createFileRoute('/_app/recipes/$id/view')({
  validateSearch: (s: Record<string, unknown>): Search => {
    const v = Number(s.version);
    return { version: Number.isInteger(v) && v > 0 ? v : undefined };
  },
  loaderDeps: ({ search }) => ({ version: search.version }),
  // Warm the same cache entries the builder reads, so the view opens with its
  // figures and Edit opens instantly. prefetchQuery never throws: a missing
  // recipe is the screen's own "not found" state.
  loader: async ({ context, params, deps }) => {
    const id = Number(params.id);
    if (!Number.isInteger(id) || id <= 0) return;
    await Promise.all([
      context.queryClient.prefetchQuery(recipeDetailQuery(id)),
      deps.version ? context.queryClient.prefetchQuery(recipeSnapshotQuery(id, deps.version)) : Promise.resolve(),
    ]);
  },
  component: ViewRecipe,
});

function ViewRecipe() {
  const { id } = Route.useParams();
  const { version } = Route.useSearch();
  return <RecipeViewScreen key={`${id}:${version ?? 'live'}`} id={Number(id)} snapId={version ?? null} />;
}
